// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gateway/v1/core.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gateway/v1/core.proto.
 */
export const file_gateway_v1_core: GenFile = /*@__PURE__*/
  fileDesc("ChVnYXRld2F5L3YxL2NvcmUucHJvdG8SCmdhdGV3YXkudjEiMwoKUGFnaW5hdGlvbhISCgpwYWdlX2luZGV4GAEgASgNEhEKCXBhZ2Vfc2l6ZRgCIAEoDSJVChJQYWdpbmF0aW9uTWV0YWRhdGESEwoLdG90YWxfY291bnQYASABKA0SKgoKcGFnaW5hdGlvbhgCIAEoCzIWLmdhdGV3YXkudjEuUGFnaW5hdGlvbkJkCg5jb20uZ2F0ZXdheS52MUIJQ29yZVByb3RvUAGiAgNHWFiqAgpHYXRld2F5LlYxygIKR2F0ZXdheVxWMeICFkdhdGV3YXlcVjFcR1BCTWV0YWRhdGHqAgtHYXRld2F5OjpWMWIGcHJvdG8z");

/**
 * Pagination is the pagination parameters of a paginated request.
 *
 * @generated from message gateway.v1.Pagination
 */
export type Pagination = Message<"gateway.v1.Pagination"> & {
  /**
   * page_index is the 1-based page index. The first page is 1; values < 1 are rejected.
   *
   * @generated from field: uint32 page_index = 1;
   */
  pageIndex: number;

  /**
   * page_size is the number of items per page.
   *
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message gateway.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_gateway_v1_core, 0);

/**
 * PaginationMetadata is the pagination information returned with a paginated response.
 *
 * @generated from message gateway.v1.PaginationMetadata
 */
export type PaginationMetadata = Message<"gateway.v1.PaginationMetadata"> & {
  /**
   * total_count is the total number of items matching the request, across every page.
   *
   * @generated from field: uint32 total_count = 1;
   */
  totalCount: number;

  /**
   * pagination is the pagination parameters used to build the page.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.PaginationMetadata.
 * Use `create(PaginationMetadataSchema)` to create a new message.
 */
export const PaginationMetadataSchema: GenMessage<PaginationMetadata> = /*@__PURE__*/
  messageDesc(file_gateway_v1_core, 1);

